<template>
  <div class="web-chat-wrapper" v-if="contactUsButton || $attrs.contactusbutton || openingHoursOnly">
    <button
      v-if="!openingHoursOnly"
      :disabled="webChatAvailable === false"
      type="button"
      class="chat-button"
      onclick="customPlugin.command('WebChat.open', getAdvancedConfig());"
      aria-label="Chat with us"
    >
      <span>Chat</span>
      <span role="presentation">&#8226;&#8226;&#8226;</span>
    </button>

    <ol>
      <li v-for="time in openingTimes" :key="time.day">
        {{ time.day }} {{ convertTo12HRFormat(time.open) }}&nbsp;-&nbsp;{{ convertTo12HRFormat(time.close) }} ({{ thisTimezone }})
      </li>
    </ol>
  </div>

  <div v-else class="live-chat-wrapper">
    <button
      :disabled="webChatAvailable === false"
      type="button"
      id="chat-button"
      class="web-chat-button"
      onclick="customPlugin.command('WebChat.open', getAdvancedConfig());"
      aria-label="Chat with us"
    >
      <span>Chat</span>
      <span role="presentation">&#8226;&#8226;&#8226;</span>
    </button>
  </div>
</template>

<script>
import { convertTo12HRFormat, getDateWithTimezone, isBusinessHours } from '@general/js/utils/dateTimeUtils';
import CommonServices from '../services/Common';
import 'regenerator-runtime';

const timeZone = 'Australia/Melbourne';

export default {
  name: 'LiveChat',

  props: {
    contactUsButton: {
      type: Boolean,
      default: false,
    },

    openingHoursOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      openingTime: null,
      openingTimes: [],
      webChatAvailable: false,
      timePageLoaded: Date.parse(getDateWithTimezone(timeZone)),
    };
  },

  computed: {
    thisTimezone() {
      const dateWithZone = new Intl.DateTimeFormat('en-US', { timeZoneName: 'long', timeZone }).format(getDateWithTimezone(timeZone));
      const timeZoneArr = dateWithZone.split(', ')[1].split(' ');
      let displayTimezone = '';
      timeZoneArr.forEach((str) => {
        displayTimezone += str[0].toUpperCase();
      });

      return displayTimezone;
    },
  },

  async mounted() {
    try {
      const openingTimes = await CommonServices.getBusinessHours();
      this.openingTime = this.getOpeningTimeObj(openingTimes);
      this.openingTimes = this.getDisplayOpeningTimes(openingTimes);
    } catch (err) {
      logger.log(err);
    }

    if (this.openingTime !== null && !this.openingHoursOnly) {
      this.isWebChatAvailable(); // check for till opening time
    }
  },

  methods: {
    /**
     * check if webchat is available or not
     */
    isWebChatAvailable() {
      setInterval(() => {
        this.webChatAvailable = isBusinessHours(this.openingTime.open, this.openingTime.close);
      }, 1000);
    },

    /**
     * this method returns today's opening time object
     * @returns obj
     */
    getOpeningTimeObj(openingTimes) {
      let today = getDateWithTimezone(timeZone).getDay();
      today = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(today);

      return openingTimes.filter((obj) => {
        return obj.day === today;
      })[0];
    },

    getDisplayOpeningTimes(openingTimes) {
      const toDisplayOpeningTimes = [];
      openingTimes.forEach((obj) => {
        const previousObj = toDisplayOpeningTimes[toDisplayOpeningTimes.length - 1];

        if (previousObj?.open === obj.open && previousObj?.close === obj.close) {
          previousObj.day = `${previousObj?.day.split(' ')[0] ?? openingTimes[0].day.split(' ')[0]} to ${obj.day}`;
        } else {
          toDisplayOpeningTimes.push({ ...obj });
        }
      });

      return toDisplayOpeningTimes;
    },

    convertTo12HRFormat,
  },
};
</script>

<style lang="scss" scoped>
.live-chat-wrapper {
  position: sticky;
  top: 100%;
  bottom: 0;
  z-index: 1;
  margin-top: $CHAT_BUTTON_TOP_MARGIN;
}
</style>
